export const Roles = {
  ADMIN: "admin",
  GUEST: "guest",
  USER: "user",
};

export const CountryCodeDefault = {
  GB: "GB",
};

export const initialFilter = {
  pageSize: 10,
  pageIndex: 0,
};

export const STATUS = {
  PENDING: "pending",
  APPROVED: "approved",
  REJECT: "reject",
};

export const defaultPassword = "Waebox2023@";

export const ROOT_API = process.env.REACT_APP_API_HOST;
export const API_ROUTES = {
  CHANGE_PASS_USER: "/api/v1/user/change-pw",
  UPDATE_COIN: "/api/v1/member/update-coin",
  SETTING_APP_NEWS: "/api/v1/post-app-settings",
  SETTING_APP_NEWS_UPDATE: "/api/v1/post-app-settings/update",
  SETTINGS: "/api/v1/settings",
  SETTING_UPDATE: "/api/v1/settings/update",
  TUBE_JUMP_LINKS: "/api/v1/link/tube-jump-links",
  VERIFY_ACCOUNT: "/api/v1/member/set-active",
  ADS: "/api/v1/ads",
  ADS_UPDATE: "/api/v1/ads/update",
  BANNER_UPDATE: "/api/v1/banners/update",
  BANNER_UPLOAD: "/api/v1/banners/upload",
  ADS_DELETE: "/api/v1/ads/delete",
  BANNER_DELETE: "/api/v1/banners/delete",
  ADS_UPDATE_STATUS: "/api/v1/ads/update-status",
  BANNER_UPDATE_STATUS: "/api/v1/banners/update-status",
  MEMBER_DELETE: "/api/v1/member/delete",
  SMTP_SERVER: "/api/v1/smtp-servers",
  SMTP_SERVER_UPDATE: "/api/v1/smtp-servers/update",
  SMTP_SERVER_UPDATE_STATUS: "/api/v1/smtp-servers/change-status",
  SMTP_SERVER_DELETE: "/api/v1/smtp-servers/delete",
  SMTP_SERVER_BACKUP_EMAIL: "/api/v1/smtp-servers/backup-email",
  SMTP_SERVER_UPDATE_BACKUP_EMAIL: "/api/v1/smtp-servers/update-backup-email",
  SMTP_SERVER_DELETE_BACKUP_EMAIL: "/api/v1/smtp-servers/delete-backup-email",
  APP_VERSION: "/api/v1/post-app-settings/app-versions",
  BANNER: "/api/v1/banners",
  USER_DELETE: "/api/v1/user/delete",
  IP_LIST: "/api/v1/ips",
  IP_CREATE: "/api/v1/ips",
  IP_DELETE: "/api/v1/ips/delete",
  SEND_EMAIL_CAMPAIGN: "/api/v1/mailers-mkt/send-by-one-smtp",
  CHANGE_LIMIT: "/api/v1/smtp-servers/set-limit",
  SEND_EMAIL: "/api/v1/send-mail",
  BLOCK_EMAIL: "/api/v1/smtp-servers/change-block",
  SYNC_EMAIL: "/api/v1/smtp-servers/sync",
  BLOCKED_LIST: "/api/v1/smtp-servers/blocked-list",
  DELETE_MULTIPLE_EMAIL: "/api/v1/smtp-servers/delete-multiple-backup",
};

export const RegisterFrom = {
  YOUTUBE_APP: "YOUTUBE_APP",
  LANDING_PAGE: "LANDING_PAGE",
  TUBE_JUMP: "TUBE_JUMP",
  Q_NEWS: "2Q_NEWS",
  Q_SPORT: "2Q_SPORT",
  KING_SPORT: "KING_SPORT",
  MINI_FOOTBALL: "MINI_FOOTBALL",
  BREAKING_NEWS: "BREAKING_NEWS",
  COMEDY_NEWS: "COMEDY_NEWS",
  MANGE_2Q: "MANGE_2Q",
  TOP_COMIC_2Q: "TOP_COMIC_2Q",
  FOOTBALL_NEWS: "FOOTBALL_NEWS",
  FOOTBALL_SCHEDULE: "FOOTBALL_SCHEDULE",
  LOTTERY_PREDICTION: "LOTTERY_PREDICTION",
  XSKT: "XSKT",
};

export const BANNER_POSITION = {
  TOP_LEFT: "TOP_LEFT",
  BOTTOM_LEFT: "BOTTOM_LEFT",
  TOP_RIGHT: "TOP_RIGHT",
  BOTTOM_RIGHT: "BOTTOM_RIGHT",
  TOP: "TOP",
  BOTTOM: "BOTTOM",
  IN_CONTENT: "IN_CONTENT",
  POPUP: "POPUP",
};

export const NewsApp = {
  Q_NEWS: "2Q_NEWS",
  Q_SPORT: "2Q_SPORT",
  KING_SPORT: "KING_SPORT",
  MINI_FOOTBALL: "MINI_FOOTBALL",
  BREAKING_NEWS: "BREAKING_NEWS",
  COMEDY_NEWS: "COMEDY_NEWS",
  MANGE_2Q: "MANGE_2Q",
  TOP_COMIC_2Q: "TOP_COMIC_2Q",
  FOOTBALL_NEWS: "FOOTBALL_NEWS",
  FOOTBALL_SCHEDULE: "FOOTBALL_SCHEDULE",
  LOTTERY_PREDICTION: "LOTTERY_PREDICTION",
};
export const ADS_TYPES = {
  POPUP: "POPUP",
  FOOTER_BANNER: "FOOTER_BANNER",
};
export const ErrorMessage = {
  The_coinPerView_is_required: "The coin per view is require",
  The_coinPerTime_is_required: "The coin per time is require",
  The_minimumView_is_required: "The minimum view is require",
  The_minimumTime_is_required: "The minimum time is require",
  The_minimumView_is_number: "The minimum view must a number",
  The_minimumTime_is_number: "The minimum time must a number",
  The_maximumView_is_required: "The maximum view is require",
  The_maximumTime_is_required: "The maximum time is require",
  The_maximumView_is_number: "The maximum view must a number",
  The_maximumTime_is_number: "The maximum time must a number",
  The_coinPerTime_is_number_min_1:
    "The coin per time must a number and greater than 1",
  The_coinPerView_is_number_min_1:
    "The coin per view must a number and greater than 1",
  The_coinRewardFinishVideo_is_number_min_1:
    "The coin reward finish video must a number and greater than 1",
  The_coinRewardFinishVideo_is_required:
    "The coin reward finish video is require",
  The_wp_domain_must_be_a_url: "The WP Domain must be a valid URL",
  The_host_name_must_be_a_host_valid: "The Host must be a valid host",
  The_host_name_is_required: "The Host is require",
  The_user_email_must_be_a_email: "The User Email must be a valid email",
  The_user_email_is_required: "The User Email is require",
  The_user_password_is_required: "The User Password is require",
  The_password_include_least_a_uppercase_number_and_letter:
    "The User Password must include least a uppercase, a number and a letter and greater than 7 character",
  Dimension_Ratio_Invalid: "Ratio dimension invalid",
  "Host is exist": "Host is exist",
  "Host name is missing": "Host name is missing",
  "Missing Id of SMTP server": "Missing Id of SMTP server",
  "SMTP Server not found": "SMTP Server not found",
  UPLOAD_XML_FILE: "Upload xml file",
};

export const PORT_SMTP = {
  FSF: "465",
  FES: "587",
};

export const REGEX_HOST = /^(([a-zA-Z0-9\-]*[a-zA-Z0-9])\.)(([a-zA-Z0-9\-]*[a-zA-Z0-9])\.)*([A-Za-z0-9\-]*[A-Za-z0-9])$/;
export const REGEX_EMAIL = /^([a-zA-Z0-9])+(([a-zA-Z0-9_.-])*)+([a-zA-Z0-9])@(([a-zA-Z0-9-])+([a-zA-Z0-9])+\.)([a-zA-Z]{2,})((\.+([a-zA-Z]{2,}))*)$/;
export const REGEX_PASSWORD = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*)[A-Za-z\d]{8,}$/;

export const BRAND_MAIL = {
  VIPPHIM: "VIPPHIM",
  EDAY: "8DAY",
  EBBB: "888B",
  TQNEWS: "2QNEWS",
  TQSPORT: "2QSPORT",
  TQLIVE: "2QLIVE",
  KING_SPORT: "KING_SPORT",
  MINI_FOOTBALL: "MINI_FOOTBALL",
  BREAKING_NEWS: "BREAKING_NEWS",
  COMEDY_NEWS: "COMEDY_NEWS",
  MANGE_2Q: "MANGE_2Q",
  TOP_COMIC_2Q: "TOP_COMIC_2Q",
};

export const PortSMTP = {
  FSF: "465",
  FES: "587",
};

export const PortSMTPOption = [
  {
    label: PortSMTP.FES,
    value: PortSMTP.FES,
  },
  {
    label: PortSMTP.FSF,
    value: PortSMTP.FSF,
  },
];
